module.exports = __webpack_public_path__ + "static/media/YouTubeSubscribeOptimized.8d42d678.png";